import {
  tenantCreate,
  tenantList,
  tenantUpdate,
  tenantUpdateAdminMemo,
  useTenantCreate,
  useTenantGetSuspense,
  useTenantList,
  useTenantListSuspense,
  useTenantUpdate,
  useTenantUpdateAdminMemo,
} from "@/api/generated/endpoints/api"
import {
  TenantGetWithFiles,
  TenantGetWithOccupants,
  TenantGetWithPlans,
  TenantGetWithRoom,
  TenantGetWithRoomPlans,
  TenantGetWithRoomProperty,
  TenantGetWithRoomPropertyOwner,
} from "@/api/generated/models"
import { tenantUpdateAdminMemoBody } from "@/api/generated/schemas/api.zod"

// API hooks and functions
export const tenantApi = {
  // Query hooks
  useTenantList,
  useTenantGetSuspense,
  useTenantListSuspense,

  // Mutation hooks
  useTenantCreate,
  useTenantUpdate,
  useTenantUpdateAdminMemo,

  // Direct API functions
  tenantCreate,
  tenantList,
  tenantUpdate,
  tenantUpdateAdminMemo,
}

export const tenantProperties = {
  TenantGetWithFiles,
  TenantGetWithOccupants,
  TenantGetWithPlans,
  TenantGetWithRoom,
  TenantGetWithRoomPlans,
  TenantGetWithRoomProperty,
  TenantGetWithRoomPropertyOwner,
}

export const tenantSchemas = {
  tenantUpdateAdminMemoBody,
}

export * as TenantModels from "./models"
export * as TenantUtils from "./utils"
